import {requestTimeout, handleResponse} from '../helpers'
import dayjs from 'dayjs'

const apiUrl = process.env.REACT_APP_API_URL
const accessToken = process.env.REACT_APP_ACCESS_TOKEN
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME
var base_uri = "bills"

export const billApi = {
    _get,
    _search,
    _add,
    _get_months,
    _bulkDelete,
    _delete,
    _update,
    _export,
    _export_data,
};



async function _get(offset, data, page_size, totalRecords) {    
    let token = localStorage.getItem(accessToken)
    if (data) {
        data['total'] = totalRecords
    }
    
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(data)   
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + base_uri+"/"+offset+"/"+page_size, requestOptions))                    
                .then(handleResponse)
                .then((response) => {                        
                    return response
                })

        
}

async function _search(offset, data, page_size, totalRecords) {    
    let token = localStorage.getItem(accessToken)
    if (data) {
        data['total'] = totalRecords
    }
    
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(data)   
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + base_uri+"/search/"+offset+"/"+page_size, requestOptions))                    
                .then(handleResponse)
                .then((response) => {                        
                    return response
                })

        
}

async function _add(data) {    
    
    let token = localStorage.getItem(accessToken)
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(data)
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + base_uri, requestOptions))                    
                .then(handleResponse)
                .then((response) => {                        
                    return response
                })                
        
}

async function _get_months() {    
    
    let token = localStorage.getItem(accessToken)
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + base_uri+"/billing-months", requestOptions))
                .then(handleResponse)
                .then((response) => {                        
                    return response
                })                
        
}

async function _update(data, id) {    
    
    let token = localStorage.getItem(accessToken)
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(data)
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + base_uri +'/'+id, requestOptions))                    
                .then(handleResponse)
                .then((response) => {                        
                    return response
                })                
        
}



async function _delete(id) {    
    
    let token = localStorage.getItem(accessToken)
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + base_uri +'/'+id, requestOptions))                    
                .then(handleResponse)
                .then((response) => {                        
                    return response
                })                
        
}


async function _bulkDelete(ids) {    
    let token = localStorage.getItem(accessToken);

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify({ ids })
    };

    return requestTimeout(apiMaxTime, fetch(apiUrl + base_uri + '/bulk-delete', requestOptions))                    
        .then(handleResponse)
        .then((response) => {                        
            return response;
        });                
}


async function _export(data) {    
    let token = localStorage.getItem(accessToken)
    const requestOptions = {
        method: 'POST',
        // mode: 'no-cors',
        headers: {
            'Content-Type': 'application/json',
            // 'Accept': 'application/json',
            'Accept': 'application/octet-stream',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(data)   
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + base_uri+"/export-data", requestOptions))                    
                .then((response) => response.blob())
                .then((blob) => {
                    const url = window.URL.createObjectURL(
                        new Blob([blob]),
                      );
                      let dd = dayjs().format('DD-MM-YYYY-HH:mm:ss')
                      const link = document.createElement('a');
                      link.href = url;
                      link.setAttribute(
                        'download',
                        `bills-export-${dd}.pdf`,
                      );
                  
                      // Append to html link element page
                      document.body.appendChild(link);
                  
                      // Start download
                      link.click();
                  
                      // Clean up and remove the link
                      link.parentNode.removeChild(link);
                      
                })

        
}

async function _export_data(data) {    
    
    let token = localStorage.getItem(accessToken)
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(data)
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + base_uri +'/export-bills-csv', requestOptions))
                .then(handleResponse)
                .then((response) => {                        
                    return response
                })                
        
}